import React from 'react';

import { Content, LayoutContainer, Main, Nav } from './ApplicationLayout/styled-components';
import { Navigation } from './Navigation';

import Footer from '../Footer';

const DEFAULT_BG = 'bmtGrey10';

export type Props = React.PropsWithChildren<{
  active: string;
  bg?: string;
}>;

export const ApplicationLayout: React.FC<Props> = ({ children, active, bg }) => {
  return (
    <LayoutContainer>
      <Nav>
        <Navigation active={active} />
      </Nav>
      <Main bg={bg ?? DEFAULT_BG}>
        <Content>{children}</Content>
        <Footer />
      </Main>
    </LayoutContainer>
  );
};
